module.exports = __webpack_public_path__ + "img/accounts.dc07c647.jpg";